<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em">Christiana Brontie was born and raised in Brontie District in Manchester, Jamaica. She is the mother of two daughters. After migrating to Canada in 1983, she obtained a bachelor of social work degree and now works as a child protection worker.</p><br/>
<p style="text-indent:0em">She is the second of four children who were raised by a single mother. As a child she was an extrovert who was very outgoing. As she grew older and experienced the harsh realities of life, she became more reserved, quiet, and introverted, while taking on the role of a follower instead of the role of a leader, as demonstrated in the pre-pubertal stage.</p><br/>
<p style="text-indent:0em">She has always been a thinker who loves deeply and still yearns of having this feeling reciprocated.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4c4a6235